import { cn } from "@sylviq/ui-react-web/lib/cn";

export type StatusTone = "success" | "warning" | "danger" | "info" | "idle";

export interface StatusDotProps {
  tone: StatusTone;
  /**
   * The status in the product's own words, e.g. "Overdue". Shown as text and
   * used as the accessible name — colour is never the only signal.
   */
  label: string;
  className?: string;
}

/** Small tone dot with its label, for status cells in lists and tables. */
export function StatusDot({ tone, label, className }: StatusDotProps) {
  return (
    <span className={cn("status-dot", className)}>
      <span
        aria-hidden="true"
        className={`status-dot__mark status-dot__mark--${tone}`}
      />
      <span>{label}</span>
    </span>
  );
}
